// import {
//     NEWSLETTER_MODAL_CLOSE,
//     NewsletterModalCloseAction,
// } from 'mk2/containers/NewsletterModal/NewsletterModal.actions';
import {
    PRIVACY_LEAFLET_ACCEPT_SUCCESS,
    PrivacyLeafletAcceptSuccessAction,
} from 'mk2/containers/PrivacyReminder/PrivacyReminder.actions';
import { Reducer } from 'redux';

import {
    DEVICE_CHANGED,
    DeviceChangedAction,
    SOFT_KEYBOARD_TOGGLE,
    SoftKeyboardToggleAction,
    VIEWPORT_CHANGED,
    ViewportChangedAction,
} from 'mk2/actions';
import { Plan, UserEntity } from 'mk2/schemas';

interface KeyboardState {
    opened: boolean;
    height: number;
}

interface ViewportState {
    width?: number;
    height?: number;
}

export interface RequestDeviceState {
    mobile: boolean;
    desktop: boolean;
    keyboard: KeyboardState;
    screen: {
        width?: number;
        height?: number;
    };
    viewport: ViewportState;
}

export interface RequestState {
    baseUrl: string;
    user: UserEntity;
    permissions: string[];
    userAgent: string;
    device: RequestDeviceState;
    phoneVerificationMode: 'newuser' | 'forced' | null;
    lastKnownUsername: string;
    privacyLeaflet: boolean;
    pregnancyNewsletterSubscribed: boolean;
    pregnancyNewsletterClosed: boolean;
}

const initialState: RequestState = {
    baseUrl: '',
    user: {
        id: 0,
        username: 'anonymous',
        avatar: '', // TODO: Add generic avatar
        avatarCampaign: '',
        // county: null,
        activePlan: Plan.FREE,
        gender: 'f',
        phoneVerified: false,
        isBlocked: false,
        likesCount: 0,
        likers: [],
    },
    permissions: [],
    userAgent: '',
    device: {
        // Defaults to mobile
        mobile: true,
        desktop: false,
        keyboard: {
            opened: false,
            height: 200, // Defaults to 200px
        },
        screen: {},
        viewport: {},
    },
    phoneVerificationMode: null,
    lastKnownUsername: null,
    privacyLeaflet: null,
    pregnancyNewsletterSubscribed: null,
    pregnancyNewsletterClosed: null,

};

declare type RequestReducerAction =
    | DeviceChangedAction
    | ViewportChangedAction
    | SoftKeyboardToggleAction
    // | NewsletterModalCloseAction
    | PrivacyLeafletAcceptSuccessAction;

const request: Reducer<RequestState> = (state = initialState, action: RequestReducerAction) => {
    switch (action.type) {
        case DEVICE_CHANGED:
            return {
                ...state,
                device: {
                    ...state.device,
                    mobile: action.mobile,
                    desktop: action.desktop,
                },
            };
        case VIEWPORT_CHANGED:
            return {
                ...state,
                device: {
                    ...state.device,
                    viewport: {
                        width: action.width,
                        height: action.height,
                    },
                },
            };
        case SOFT_KEYBOARD_TOGGLE:
            return {
                ...state,
                device: {
                    ...state.device,
                    keyboard: {
                        opened: action.opened,
                        height: action.height,
                    },
                },
            };
        // case NEWSLETTER_MODAL_CLOSE:
        //     return {
        //         ...state,
        //         pregnancyNewsletterClosed: true,
        //     };
        case PRIVACY_LEAFLET_ACCEPT_SUCCESS:
            return {
                ...state,
                privacyLeaflet: true,
            };
        default:
            return state;
    }
};

export default request;

export const getBaseUrl = (state: RequestState): string => state.baseUrl;
export const getUser = (state: RequestState): UserEntity => state.user;
export const getPermissions = (state: RequestState): string[] => state.permissions;
export const getUserAgent = (state: RequestState): string => state.userAgent;
export const getDevice = (state: RequestState): RequestDeviceState => state.device;
export const getDeviceViewport = (state: RequestState): ViewportState => state.device.viewport;
export const getDeviceMobile = (state: RequestState): boolean => state.device.mobile;
export const getDeviceDesktop = (state: RequestState): boolean => state.device.desktop;
export const getDeviceKeyboard = (state: RequestState): KeyboardState => state.device.keyboard;
export const getPhoneVerificationMode = (state: RequestState) => state.phoneVerificationMode;
export const getPrivacyLeaflet = (state: RequestState): boolean => state.privacyLeaflet;
export const getPregnancyNewsletterSubscribed = (state: RequestState): boolean => state.pregnancyNewsletterSubscribed;
export const getPregnancyNewsletterClosed = (state: RequestState): boolean => state.pregnancyNewsletterClosed;
